import React, { useContext } from "react";
import SectionBlock from "../../../../global/components/FeatureCard/SectionBlock";
import secureAccessControl from "../../../../assets/images/tenantVideo/secure-access-control.png";
import videoCalling from "../../../../assets/images/tenantVideo/video-calling.png";
import visitorInvite from "../../../../assets/images/tenantVideo/sicunet directory mobile app- invite visitors 3.1.svg";
import videoDirectoryIntercom from "../../../../assets/images/tenantVideo/video-directory-intercom.png";
import CatalogueBackground from "../../../../assets/images/download-cutsheet2.png";
import useSWR from "swr";
import DownloadSection from "../../../../lib/downloadSection";
import { fetcher } from "../../../../lib/apiConstants";
import { LoginContext } from "../../../../lib/loginContext";

const PAGE_X = "px-6 lg:px-[120px]";

const FeaturePill = ({ label }) => (
  <div className="bg-[#EAF0FF] inline-flex min-h-8 items-center shrink-0 px-1 py-2 rounded-[10px] max-w-full">
    <span className="text-[16px] text-[#5b5b5b] px-2 font-normal font-['Poppins'] leading-[26px]">
      {label}
    </span>
  </div>
);

const sections = [
  {
    image: secureAccessControl,
    label: "Tenant 8 : Secure, Seamless and Smart Access Control",
    description:
      "The Tenant 8 directory device connects seamlessly to Neptune 2.0 via secure Ethernet communication, delivering reliable and protected access control. Designed as an all-in-one reader and door controller, Tenant 8 simplifies installation while enhancing system performance. A single, intuitive user interface lets you manage the entire system with ease. Even during network outages, the system continues to operate smoothly, with data securely stored at the edge to ensure uninterrupted access and complete peace of mind.",
    imageLeft: true,
    imageBg: "#f8f8f8",
    textBg: "#f8f8f8",
    textAlign: "left",
    bodyColor: "#3b3b3b",
    imageMaxWidth: "604px",
    sectionHeight: "540px",
  },
  {
    image: videoCalling,
    label: "Video Calling",
    description:
      "Experience seamless video calling from the Directory device to your mobile phone, enabling real-time visitor verification and communication. View live video, confirm the person at the door, and unlock access remotely through a single, secure mobile app—bringing convenience, security, and control together in one place.",
    imageLeft: false,
    imageBg: "#ffffff",
    textBg: "#ffffff",
    textAlign: "right",
    bodyColor: "#3b3b3b",
    imageMaxWidth: "604px",
    sectionHeight: "540px",
  },
  {
    image: visitorInvite,
    label: "Visitor Invite",
    description:
      "Easily invite visitors directly from the Directory mobile app by sending an invitation to their email address. Once sent, the visitor receives a temporary access credential via email, allowing them to enter through doors equipped with the Directory device during the approved time period. This enables secure, controlled access without interrupting or bothering the tenant—making visitor management simple, flexible, and hassle-free.",
    imageLeft: true,
    imageBg: "#f8f8f8",
    textBg: "#f8f8f8",
    textAlign: "left",
    bodyColor: "#3b3b3b",
    imageMaxWidth: "464px",
    sectionHeight: "540px",
  },
  {
    image: videoDirectoryIntercom,
    label: "Tenant 8 Video Directory Intercom",
    description:
      "All your access, all in one place. Effortlessly manage video calls, VOIP, doors, and elevators from a single, intuitive interface.",
    imageLeft: false,
    imageBg: "#ffffff",
    textBg: "#ffffff",
    textAlign: "right",
    bodyColor: "#3b3b3b",
    imageMaxWidth: "540px",
    sectionHeight: "540px",
  },
];

const featureColumns = [
  [
    "Interfaces to all Sicunet Hardware*",
    "On premise and or cloud management",
    "Capacitive multi-touch IPS screen",
    "Adaptive light compensation",
    "Integrated Reader: Mifare, Keypad, QR code",
    "Email Enrollment – System sends invitation for directory enrolment",
    "Two-way video calling with voice, remote unlock, and visitor self-view during the call.",
  ],
  [
    "Credential issuance for visitors from app",
    "DSP Background noise cancelling",
    "SSL with AES 256 encryption",
    "Wall or Pedestal Mount",
    "Thumb drive video event storage",
    "Indoor / Outdoor IP66",
    "Customizable screen display with location details, directory search, operator help, PIN keypad, and live visitor preview.",
  ],
];

export const TenantVideoContent = () => {
  const { data: products, isLoading: productsLoading } = useSWR(
    "products/",
    fetcher
  );
  const { isLoggedIn } = useContext(LoginContext);

  return (
    <div className="bg-white w-full">
      <section
        className={`bg-white flex flex-col items-center justify-center gap-6 ${PAGE_X} pt-28 sm:pt-24 min-h-[258px] text-center`}
      >
        <h1 className="text-black text-[32px] font-medium font-['Inter'] leading-normal max-w-[1004px]">
          Tenant 8 Smart Video Directory & Access Control
        </h1>
        <p className="text-[#5b5b5b] text-[20px] font-medium font-['Poppins'] leading-normal  max-w-[872px]">
          Unify video intercom, visitor management, mobile access, and secure
          door control into one intelligent all-in-one entry experience.
        </p>
      </section>

      <div className="w-full bg-white mt-6">
        {sections.map((section) => (
          <SectionBlock key={section.label} {...section} />
        ))}
      </div>

      <section className={`bg-white ${PAGE_X} py-[60px]`}>
        <div className="max-w-[1184px] mx-auto flex flex-col items-center gap-9">
          <div className="flex flex-col items-center gap-4 text-center max-w-[1044px]">
            <h2 className="text-[24px] font-medium text-black font-['Inter'] leading-normal">
              Tenant 8 Video Directory Intercom FEATURES
            </h2>
            <p className="text-base text-[#5b5b5b] font-normal font-['Poppins'] leading-[26px] max-w-[594px]">
              All your access, all in one place. Effortlessly manage video
              calls, VOIP, doors, and elevators from a single, intuitive
              interface.
            </p>
          </div>

          <div className="flex flex-col lg:flex-row gap-4 lg:gap-8 w-full items-start justify-between">
            {featureColumns.map((column, colIdx) => (
              <div
                key={colIdx}
                className="flex flex-col gap-4 items-start w-full lg:w-[48%]"
              >
                {column.map((feature) => (
                  <FeaturePill key={feature} label={feature} />
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>

      {isLoggedIn && (
        <div className={` mx-auto pt-[60px]`}>
          <DownloadSection
            title="Cut Sheet"
            description="Learn about Tenant 8 Video Directory Intercom"
            backgroundImage={CatalogueBackground}
            buttonText="Download Now"
            linkField="flyer_link"
            products={products || []}
            isLoading={productsLoading}
            filterBySlug="tenant-8"
            showOnlyFirst={true}
          />
        </div>
      )}
    </div>
  );
};

export default TenantVideoContent;
